/*
 * Action Types
 */
export enum AnomaliesTypes {
  LIST_ANOMALIES_REQUEST = '@anomalies/LIST_ANOMALIES_REQUEST',
  LIST_ANOMALIES_SUCCESS = '@anomalies/LIST_ANOMALIES_SUCCESS',
  LIST_ANOMALIES_FAILURE = '@anomalies/LIST_ANOMALIES_FAILURE',

  LIST_ANOMALY_USERS_REQUEST = '@anomalies/LIST_ANOMALY_USERS_REQUEST',
  LIST_ANOMALY_USERS_SUCCESS = '@anomalies/LIST_ANOMALY_USERS_SUCCESS',
  LIST_ANOMALY_USERS_FAILURE = '@anomalies/LIST_ANOMALY_USERS_FAILURE',
}

/*
 * Data types
 */
export interface AnomalyInterface {
  id: string;
  name?: string;
  title: string;
  description: string;
  estimation: number;
  createdAt: string;
  updatedAt: string;
}

export interface AnomalyUserInterface {
  id: string;
  shortId?: string;
  name: string;
  nickname?: string;
  email?: string;
  phone?: string;
  photoUrl?: string;
  sex?: string;
  ethnicity?: string;
  birthplace?: string;
  birthdate?: string;
  facialStatus?: string;
}

export interface AnomalyEntryInterface {
  id: string;
  usedAt?: string;
  value?: number;
  paymentType?: number;
  latitude?: number;
  longitude?: number;
  number?: string;
  isVt?: number;
  userId?: string;
  lineSectionId?: string;
  tripId?: string;
  transportOperatorId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type AnomalyRow = AnomalyUserInterface | AnomalyEntryInterface;

/*
 * State type
 */
export interface AnomaliesState {
  readonly anomalies: AnomalyInterface[];
  readonly totalCount: number;
  readonly anomalyUsers: AnomalyRow[];
  readonly loading: boolean;
  readonly error: boolean;
}
